export default {
  UPDATE_RESOURCES: 'UPDATE_RESOURCES',
  DELETE_RESOURCES: 'DELETE_RESOURCES'

  // These will be used in Redux Resource v3.1.0. For now,
  // they are reserved action types.
  // REQUEST_IDLE: 'REQUEST_IDLE',
  // REQUEST_PENDING: 'REQUEST_PENDING',
  // REQUEST_FAILED: 'REQUEST_FAILED',
  // REQUEST_SUCCEEDED: 'REQUEST_SUCCEEDED',
};